import Vue from "vue";
import Router from "vue-router";
import { exportAllMenuList } from "@/theme/index.js";
Vue.use(Router);

/* Layout */
import Layout from "@/layout";
import Layout1 from "@/layout/index1.vue";
import indexHome from "@/layout/indexHome.vue";
import indexHomeOther from "@/layout/indexHomeOther.vue";

import noLayout from "@/layout/noLayout.vue";
import { getNowMenuList } from "@/theme";

/**
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes data mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
const EmptyComponent = {
  template: "", // 空模板，即没有任何内容
};
// //console.log(this.$router)
export const constantRoutes = [].concat(exportAllMenuList(), [
  {
    path: "/",
    component: indexHome,
    name: "home",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/home/index"),
      },
    ],
  },
  {
    path: "/rcep/home",
    component: indexHomeOther,
    name: "rcepHome",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/home/homeOther/rcepHome"),
      },
    ],
  },
  {
    path: "/cptpp/home",
    component: indexHomeOther,
    name: "cptppHome",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/home/homeOther/cptppHome"),
      },
    ],
  },
  {
    path: "/chplt/home",
    component: indexHomeOther,
    name: "chpltHome",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/home/homeOther/chpltHome"),
      },
    ],
  },
  {
    path: "/login",
    component: Layout1,
    name: "login",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/login/index"),
      },
    ],
  },
  {
    path: "/regist",
    component: Layout1,
    name: "regist",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/regist/index"),
      },
    ],
  },

  {
    path: "/newComtrade",
    component: noLayout,
    name: "newComtrade",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/about/newComtrade.vue"),
      },
    ],
  },
  {
    path: "/detail/:type",
    component: Layout1,
    name: "detail",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/detail/index"),
      },
    ],
  },
  {
    path: "/details/:num",
    component: Layout1,
    name: "details",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/data/goods/detail"),
      },
    ],
  },
  {
    path: "/forget",
    component: Layout1,
    name: "forget",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/forget/index"),
      },
    ],
  },
  {
    path: "/projectMv",
    component: Layout1,
    name: "projectMv",
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/projectMv/index"),
      },
    ],
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  // {
  //   path: "/data",
  //   component: Layout,
  //   redirect: "/data/goods",
  //   name: "data",
  //   meta: {
  //     title: "数据",
  //     icon: "iconfont iconshuju1",
  //   },
  //   children: [
  //     {
  //       path: "goods",
  //       name: "goodsTrade",
  //       redirect: "/data/goods/world",
  //       component: () => import("@/views/data/goods"),
  //       meta: { title: "货物贸易" },
  //       children: [
  //         {
  //           path: "world",
  //           redirect: "/data/goods/world/monthly",
  //           newpath: "/data/goods/world/detail",
  //           component: () => import("@/views/data/goods/world"),
  //           name: "world",
  //           meta: { title: "世界" },
  //           children: [
  //             {
  //               path: "monthly",
  //               component: () => import("@/views/data/goods/world/monthly"),
  //               name: "monthly",
  //               meta: { title: "世界月度" },
  //             },
  //             {
  //               path: "annual",
  //               component: () => import("@/views/data/goods/world/annual"),
  //               name: "annual",
  //               meta: { title: "世界年度" },
  //             },
  //             {
  //               path: "detail",
  //               hidden: true,
  //               component: () => import("@/views/data/goods/world/detail"),
  //               name: "detail",
  //               meta: { title: "数据介绍" },
  //             },
  //           ],
  //         },
  //         {
  //           path: "asean",
  //           redirect: "/data/goods/asean/monthly",
  //           newpath: "/data/goods/asean/detail",
  //           component: () => import("@/views/data/goods/asean"),
  //           name: "asean",
  //           meta: { title: "东盟" },
  //           children: [
  //             {
  //               path: "monthly",
  //               component: () => import("@/views/data/goods/asean/monthly"),
  //               name: "monthly",
  //               meta: { title: "东盟季度" },
  //             },
  //             {
  //               path: "annual",
  //               component: () => import("@/views/data/goods/asean/annual"),
  //               name: "annual",
  //               meta: { title: "东盟年度" },
  //             },
  //             {
  //               path: "detail",
  //               hidden: true,
  //               component: () => import("@/views/data/goods/asean/detail"),
  //               name: "detail",
  //               meta: { title: "数据介绍" },
  //             },
  //           ],
  //         },
  //         {
  //           path: "asia",
  //           redirect: "/data/goods/asia",
  //           component: () => import("@/views/data/goods/asia"),
  //           name: "asia",
  //           meta: { title: "亚洲" },
  //           children: [
  //             {
  //               path: "china",
  //               newpath: "/data/goods/asia/china/detail",
  //               component: () => import("@/views/data/goods/asia/china"),
  //               name: "china",
  //               meta: {
  //                 title: "中国",
  //                 showOnlyOneChild: true,
  //                 icon: "iconshuju2 2-3-1",
  //               },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/china/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "中国月度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/asia/china/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //             {
  //               path: "japan",
  //               newpath: "/data/goods/asia/japan/detail",
  //               component: () => import("@/views/data/goods/asia/japan"),
  //               name: "thailand",
  //               meta: { title: "日本", icon: "iconshuju2 2-3-2" },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/japan/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "日本月度" },
  //                 },
  //                 {
  //                   path: "annual",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/japan/annual"),
  //                   name: "annual",
  //                   meta: { title: "日本年度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/asia/japan/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //             {
  //               path: "korea",
  //               newpath: "/data/goods/asia/korea/detail",
  //               component: () => import("@/views/data/goods/asia/korea"),
  //               name: "thailand",
  //               meta: { title: "韩国", icon: "iconshuju2 2-3-3" },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/korea/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "韩国月度" },
  //                 },
  //                 {
  //                   path: "annual",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/korea/annual"),
  //                   name: "annual",
  //                   meta: { title: "韩国年度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/asia/korea/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //             {
  //               path: "thailand",
  //               newpath: "/data/goods/asia/thailand/detail",
  //               component: () => import("@/views/data/goods/asia/thailand"),
  //               name: "thailand",
  //               meta: { title: "泰国", icon: "iconshuju2 2-3-4" },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/thailand/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "泰国月度" },
  //                 },
  //                 {
  //                   path: "annual",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/thailand/annual"),
  //                   name: "annual",
  //                   meta: { title: "泰国年度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/asia/thailand/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //             {
  //               path: "philippines",
  //               newpath: "/data/goods/asia/philippines/detail",
  //               component: () => import("@/views/data/goods/asia/philippines"),
  //               name: "philippines",
  //               meta: { title: "菲律宾", icon: "iconshuju2 2-3-5" },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/philippines/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "菲律宾月度" },
  //                 },
  //                 {
  //                   path: "annual",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/philippines/annual"),
  //                   name: "annual",
  //                   meta: { title: "菲律宾年度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/asia/philippines/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //             {
  //               path: "malaysia",
  //               newpath: "/data/goods/asia/malaysia/detail",
  //               component: () => import("@/views/data/goods/asia/malaysia"),
  //               name: "philippines",
  //               meta: { title: "马来西亚", icon: "iconshuju2 2-3-6" },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/malaysia/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "马来西亚月度" },
  //                 },
  //                 {
  //                   path: "annual",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/malaysia/annual"),
  //                   name: "annual",
  //                   meta: { title: "马来西亚年度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/asia/malaysia/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //             {
  //               path: "indonesia",
  //               newpath: "/data/goods/asia/indonesia/detail",
  //               component: () => import("@/views/data/goods/asia/indonesia"),
  //               name: "indonesia",
  //               meta: { title: "印度尼西亚", icon: "iconshuju2 2-3-7" },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/indonesia/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "印尼月度" },
  //                 },
  //                 {
  //                   path: "annual",
  //                   component: () =>
  //                     import("@/views/data/goods/asia/indonesia/annual"),
  //                   name: "annual",
  //                   meta: { title: "印尼年度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/asia/indonesia/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //         {
  //           path: "bmz",
  //           redirect: "/data/goods/bmz/jnd",
  //           component: () => import("@/views/data/goods/bmz"),
  //           name: "bmz",
  //           meta: { title: "北美洲" },
  //           children: [
  //             {
  //               path: "jnd",
  //               newpath: "/data/goods/bmz/jnd/detail",
  //               redirect: "/data/goods/bmz/jnd/monthlyjc",
  //               component: () => import("@/views/data/goods/bmz/jnd"),
  //               name: "jnd",
  //               meta: { title: "加拿大", icon: "iconshuju2 2-4-1" },
  //               children: [
  //                 {
  //                   path: "monthlyjc",
  //                   component: () =>
  //                     import("@/views/data/goods/bmz/jnd/monthlyjc"),
  //                   name: "monthlyjc",
  //                   meta: { title: "加拿大本地出口月度" },
  //                 },
  //                 {
  //                   path: "monthlyj",
  //                   component: () =>
  //                     import("@/views/data/goods/bmz/jnd/monthlyj"),
  //                   name: "monthlyj",
  //                   meta: { title: "加拿大进口月度" },
  //                 },
  //                 {
  //                   path: "monthlyc",
  //                   component: () =>
  //                     import("@/views/data/goods/bmz/jnd/monthlyc"),
  //                   name: "monthlyc",
  //                   meta: { title: "加拿大总出口月度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/bmz/jnd/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //         {
  //           path: "nmz",
  //           redirect: "/data/goods/nmz/bilu",
  //           component: () => import("@/views/data/goods/nmz"),
  //           name: "nmz",
  //           meta: { title: "南美洲" },
  //           children: [
  //             {
  //               path: "bilu",
  //               newpath: "/data/goods/nmz/bilu/detail",
  //               redirect: "/data/goods/nmz/bilu/monthly",
  //               component: () => import("@/views/data/goods/nmz/bilu"),
  //               name: "bilu",
  //               meta: { title: "秘鲁", icon: "iconshuju2 2-5-1" },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/nmz/bilu/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "秘鲁月度" },
  //                 },
  //                 {
  //                   path: "annual",
  //                   component: () =>
  //                     import("@/views/data/goods/nmz/bilu/annual"),
  //                   name: "annual",
  //                   meta: { title: "秘鲁年度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/nmz/bilu/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //             {
  //               path: "zhili",
  //               newpath: "/data/goods/nmz/zhili/detail",
  //               redirect: "/data/goods/nmz/zhili/monthly",
  //               component: () => import("@/views/data/goods/nmz/zhili"),
  //               name: "zhili",
  //               meta: { title: "智利", icon: "iconshuju2 2-5-2" },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/nmz/zhili/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "智利月度" },
  //                 },
  //                 {
  //                   path: "annual",
  //                   component: () =>
  //                     import("@/views/data/goods/nmz/zhili/annual"),
  //                   name: "annual",
  //                   meta: { title: "智利年度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/nmz/zhili/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //         {
  //           path: "dyz",
  //           redirect: "/data/goods/dyz/xxl",
  //           component: () => import("@/views/data/goods/dyz"),
  //           name: "dyz",
  //           meta: { title: "大洋洲" },
  //           children: [
  //             {
  //               path: "xxl",
  //               newpath: "/data/goods/dyz/xxl/detail",
  //               redirect: "/data/goods/dyz/xxl/monthly",
  //               component: () => import("@/views/data/goods/dyz/xxl"),
  //               name: "xxl",
  //               meta: { title: "新西兰", icon: "iconshuju2 2-6-1" },
  //               children: [
  //                 {
  //                   path: "monthly",
  //                   component: () =>
  //                     import("@/views/data/goods/dyz/xxl/monthly"),
  //                   name: "monthly",
  //                   meta: { title: "新西兰月度" },
  //                 },
  //                 {
  //                   path: "annual",
  //                   component: () =>
  //                     import("@/views/data/goods/dyz/xxl/annual"),
  //                   name: "annual",
  //                   meta: { title: "新西兰年度" },
  //                 },
  //                 {
  //                   path: "detail",
  //                   hidden: true,
  //                   component: () =>
  //                     import("@/views/data/goods/dyz/xxl/detail"),
  //                   name: "detail",
  //                   meta: { title: "数据介绍" },
  //                 },
  //               ],
  //             },
  //           ],
  //         },

  //       ],
  //     },
  //     {
  //       path: "service-trade",
  //       name: "serviceTrade",
  //       redirect: "/data/service-trade/world",
  //       component: () => import("@/views/data/service-trade"),
  //       meta: { title: "服务贸易" },
  //       children: [
  //         {
  //           path: "world",
  //           newpath: "/data/service-trade/world/detail",
  //           redirect: "/data/goods/world/annual",
  //           component: () => import("@/views/data/service-trade/world"),
  //           name: "world",
  //           meta: {
  //             title: "世界",
  //             showOnlyOneChild: true,
  //             icon: "iconshuju2 4-1",
  //           },
  //           children: [
  //             {
  //               path: "annual",
  //               component: () =>
  //                 import("@/views/data/service-trade/world/annual"),
  //               name: "annual",
  //               meta: { title: "世界年度" },
  //             },
  //             {
  //               path: "detail",
  //               hidden: true,
  //               component: () =>
  //                 import("@/views/data/service-trade/world/detail"),
  //               name: "detail",
  //               meta: { title: "数据介绍" },
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       path: "trade-index",
  //       name: "goodsIndex",
  //       redirect: "/data/goods-index/china",
  //       component: () => import("@/views/data/trade-index"),
  //       meta: { title: "贸易指数" },
  //       children: [
  //         {
  //           path: "china",
  //           newpath: "/data/trade-index/china/detail",
  //           redirect: "/data/goods/asia/china/monthly",
  //           component: () => import("@/views/data/trade-index/china"),
  //           name: "china",
  //           meta: {
  //             title: "中国",
  //             showOnlyOneChild: true,
  //             icon: "iconshuju2 3-1",
  //           },
  //           children: [
  //             {
  //               path: "monthly",
  //               component: () =>
  //                 import("@/views/data/trade-index/china/monthly"),
  //               name: "monthly",
  //               meta: { title: "中国月度" },
  //             },
  //             {
  //               path: "detail",
  //               hidden: true,
  //               component: () =>
  //                 import("@/views/data/trade-index/china/detail"),
  //               name: "detail",
  //               meta: { title: "数据介绍" },
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },

  {
    path: "/monitor",
    // newpath: "/monitor/detail",
    component: Layout,
    redirect: "/monitor/overview",
    name: "monitor",
    meta: { title: "监测", icon: "iconfont iconjiance" },
    children: [
      {
        path: "overview",
        name: "overview",
        component: () => import("@/views/monitor/overview/index"),
        meta: { title: "贸易概况" },
      },
      {
        path: "structure",
        name: "structure",
        component: () => import("@/views/monitor/structure/index"),
        meta: { title: "商品结构" },
      },
      {
        path: "sub-structure",
        name: "structure",
        hidden: true,
        component: () => import("@/views/monitor/structure/sub-structure"),
        meta: { title: "商品结构" },
      },
      {
        path: "competitiveness",
        name: "competitiveness",
        component: () => import("@/views/monitor/competitiveness/index"),
        meta: { title: "贸易竞争" },
      },
      // {
      //   path: "detail",
      //   hidden: true,
      //   component: () => import("@/views/monitor/detail"),
      //   name: "detail",
      //   meta: { title: "数据介绍" },
      // },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/data/goods/asia/china/monthly",
    meta: { showOnlyOneChild: false, icon: "iconshuju2" },
    children: [
      {
        path: "report",
        name: "report",
        component: () => import("@/views/report/index"),
        meta: { title: "报告", icon: "iconfont iconbaogao" },
      },
    ],
  },
  // {
  //   path: '/specialReport',
  //   component: Layout,
  //   redirect: '/specialReport/china',
  //   name: 'specialReport',
  //   meta: { title: '中美贸易摩擦专报', icon: 'iconfont1 icon-zhuanbao-tb' },
  //   children: [
  //     {
  //       path: 'china',
  //       name: 'china',
  //       component: () => import('@/views/specialReport/index'),
  //       meta: {
  //         title: '中国版',
  //         projectId: 200, // 中美贸易专报在可视化平台中的项目id
  //         publishPlatformId: 2121 // 中美贸易专报在可视化平台中的平台代码id
  //       }
  //     },
  //     {
  //       path: 'usa',
  //       name: 'usa',
  //       component: () => import('@/views/specialReport/index'),
  //       meta: {
  //         title: '美国版',
  //         projectId: 207, // 中美贸易专报在可视化平台中的项目id
  //         publishPlatformId: 1234 // 中美贸易专报在可视化平台中的平台代码id
  //        }
  //     },
  //   ]
  // },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/data/goods/china/monthly',
  //   meta: {showOnlyOneChild: false},
  //   children: [{
  //     path: 'specialReport',
  //     name: 'specialReport',
  //     component: () => import('@/views/specialReport/index'),
  //     meta: {
  //       title: '中美贸易摩擦专报',
  //       icon: 'iconfont1 icon-zhuanbao-tb',
  //       projectId: 136, // 中美贸易专报在可视化平台中的项目id
  //       publishPlatformId: 0 // 中美贸易专报在可视化平台中的平台代码id
  //     }
  //   }]
  // },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/data/goods/china/monthly',
  //   meta: {showOnlyOneChild: false},
  //   children: [{
  //     path: 'chinaReport',
  //     name: 'chinaReport',
  //     component: () => import('@/views/specialReport/index'),
  //     meta: {
  //       title: '中国版',
  //       icon: 'iconfont1 icon-zhuanbao-tb',
  //       projectId: 200, // 中美贸易专报在可视化平台中的项目id
  //       publishPlatformId: 2121 // 中美贸易专报在可视化平台中的平台代码id
  //     }
  //   }]
  // },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/data/goods/china/monthly',
  //   meta: {showOnlyOneChild: false},
  //   children: [{
  //     path: 'useReport',
  //     name: 'useReport',
  //     component: () => import('@/views/specialReport/index'),
  //     meta: { title: '美国版', icon: 'iconfont1 icon-zhuanbao-tb' }
  //   }]
  // },

  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
]);
// .concat(getNowMenuList("chplt")).concat(getNowMenuList("cptpp")).concat(getNowMenuList("rcep"))

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
